export enum SidebarTab {
  Dataroom = 'dataroom',
  Settings = 'settings',
  Questions = 'questions',
}
